/**
 * Backend authority strings (Spring Security authorities).
 *
 * Single source of truth so menus (menu-items/*), route guards, and in-component permission checks
 * gate the UI with the same constant the backend @PreAuthorize expects — no scattered string literals.
 * Not every call site is migrated yet; use these when adding/touching permission checks.
 */
export const AUTHORITIES = {
    HISTORY_VIEW: 'HISTORY_VIEW',
    INFRA_VIEW: 'INFRA_VIEW',
    MAIL_SEND: 'MAIL_SEND',
    BILLING_VIEW: 'BILLING_VIEW',
    BILLING_EDIT: 'BILLING_EDIT',
    BILLING_DOWN: 'BILLING_DOWN',
    BULK_VIEW: 'BULK_VIEW'
} as const;

export type Authority = (typeof AUTHORITIES)[keyof typeof AUTHORITIES];
